import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function SecurityIncidents() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <button onClick={() => navigate('/dashboard')} className="mb-4 text-blue-600 hover:underline">← Back</button>
        <h1 className="text-3xl font-bold mb-6">Security Incidents</h1>
        <div className="bg-white rounded-lg shadow p-6"><p>Security incident management coming soon...</p></div>
      </div>
    </div>
  );
}
